import { CalculationAlt } from '@carbon/react/icons';
import { BaseCard } from 'components/base-card';
import { CalculationIconTrigger } from 'components/calculation-icon-trigger';
import { CalculationType } from 'components/nri-table/types';
import { TractNriMatrixPopup } from './tract-nri-matrix-popup';
import styles from './tract-nri-matrix-card.module.scss';

interface TractNriMatrixCardProps {
  tractId: string;
  /** For LTD slots, this is the slot ID. For wells, this should be empty/undefined. */
  slotId?: string;
  /** The well UWI - used for non-LTD slots */
  wellUwi?: string;
  /** On a package page: the matrix sums only the package's own Subtracts of the Tract. */
  packageId?: number;
  calculationType: CalculationType;
}

export const TractNriMatrixCard = ({
  tractId,
  slotId,
  wellUwi,
  packageId,
  calculationType,
}: TractNriMatrixCardProps) => {
  const renderTrigger = (active: boolean, toggle: () => void) => (
    <CalculationIconTrigger
      definition="Show NRI Matrix"
      active={active}
      onClick={toggle}
    >
      <div className={styles.iconContainer}>
        <CalculationAlt aria-hidden="true" role="img" />
      </div>
    </CalculationIconTrigger>
  );

  return (
    <BaseCard
      contentClassName={styles.cardContent}
      renderTrigger={renderTrigger}
      content={
        <TractNriMatrixPopup
          tractId={tractId}
          slotId={slotId}
          wellUwi={wellUwi}
          packageId={packageId}
          calculationType={calculationType}
        />
      }
    />
  );
};
